var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgStepImg = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 20,
    viewBox: "0 0 10 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.16114 15.6338C1.67843 17.7703 2.51416 19.9543 4.7906 19.9543C7.06705 19.9543 7.90277 17.7703 8.42006 15.6338C8.4853 15.3645 8.42331 15.0802 8.25199 14.8625C8.08066 14.6447 7.81891 14.5176 7.54181 14.5176H2.0394C1.76229 14.5176 1.50054 14.6447 1.32922 14.8625C1.15789 15.0802 1.0959 15.3646 1.16114 15.6338ZM4.79059 18.1471C4.44438 18.1471 3.84405 18.1471 3.23355 16.3248H6.34777C5.73727 18.1471 5.13695 18.1471 4.79073 18.1471H4.79066H4.79059Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.487523 11.9206C0.551439 12.3655 0.932583 12.6958 1.38198 12.6958H8.19885C8.64831 12.6958 9.02945 12.3655 9.09331 11.9206C9.17222 11.3711 9.25216 10.772 9.33764 10.0894V10.0893C9.84921 5.99892 9.35855 3.07524 7.87933 1.39958C7.07108 0.483976 6.00294 0 4.79041 0C3.57788 0 2.50975 0.483976 1.7015 1.39958C0.222282 3.07524 -0.268381 5.99886 0.243186 10.0894C0.328908 10.7737 0.408848 11.3727 0.487523 11.9206ZM7.54439 9.86482C7.49885 10.2287 7.45493 10.5682 7.41192 10.8886H2.16891C2.12602 10.5687 2.0821 10.2292 2.03644 9.86494C1.60457 6.41157 1.9668 3.82988 3.05638 2.59554C3.51813 2.07247 4.10156 1.80723 4.79041 1.80723C5.47927 1.80723 6.0627 2.07247 6.52445 2.59554C7.61403 3.82988 7.97626 6.41157 7.54439 9.86482Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgStepImg);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/stepImg.97411efa12f703376b3c098d7372826e.svg";